import { mount } from 'svelte'
import './app.css'
import App from './App.svelte'
import "https://esm.town/v/dinavinter/dcom/spotcard"
import htmx from 'htmx.org'
import 'htmx-ext-sse'
const app = mount(App, {
  target: document.getElementById('app')!,
})

export default app
